import { Component } from '@angular/core';
import {BaseState} from "@base/entities/BaseEntities";
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";

class State extends BaseState {}

@Component({
    selector: 'app-demo-pages',
    templateUrl: './demo-pages.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoPagesComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService) {
        super(A, 'DemoPagesComponent', State);
    }
    
    public OnHeadersExampleClicked() {
        this.Navigate(['demo/page-examples/header-buttons']);
    }
    
    public OnToolbarExampleClicked() {
        this.Navigate(['demo/page-examples/toolbar-buttons']);
    }
}
